// @flow
import type { FSA } from 'types/redux';
import { API_REQUEST } from 'middlewares/api-middleware';
import * as RequestResultCases from 'omega-rtc/middlewares/api-middleware';

export const GET_COUNTRIES = 'GET_COUNTRIES';

export function getCountries(): FSA {
  // Retrieve countries from config.json if it is defined
  const countries = window.Grab.config.COUNTRIES;
  if (countries) {
    return {
      type: GET_COUNTRIES + RequestResultCases.SUCCESS,
      payload: countries,
    };
  }

  return {
    type: GET_COUNTRIES,
    payload: {
      method: 'GET',
      url: '/countries',
    },
    meta: {
      [API_REQUEST]: true,
    },
  };
}
